export default "__VITE_ASSET__SbiOYRLs__"